import TextareaAutosize from 'react-textarea-autosize';
import styled, { createGlobalStyle } from 'styled-components';

import { media } from './theme';

interface StyledOrderedListProps {
	icon?: 'bullseye' | 'brain';
}

export const StyledOrderedList = styled.ol<StyledOrderedListProps>`
	counter-reset: outcome-counter;
	list-style: none;
	list-style-type: none !important;
	padding-left: 40px;

	p,
	span {
		color: var(--body-text) !important;
	}

	> li {
		counter-increment: outcome-counter;
		margin-bottom: var(--spacing-8);
		position: relative;
	}

	> li p:last-of-type br {
		display: none;
	}

	> li::before {
		align-items: center;
		background-color: ${(props) => (props.icon ? 'transparent' : 'var(--org-color)')};
		background-image: ${(props) => {
			if (props.icon === 'bullseye') {
				return `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ni4xIDQ2LjEiPgogIDxnIGZpbGw9IiNjNDM0MjciPgogICAgPHBhdGggZD0iTTIzIDBhMjMgMjMgMCAxMC4xIDQ2LjIgMjMgMjMgMCAwMDAtNDYuMnptMCAzOS4xQTE2IDE2IDAgMTEyMyA3IDE2IDE2IDAgMDEyMyAzOXoiLz4KICAgIDxjaXJjbGUgY3g9IjIzLjEiIGN5PSIyMy4xIiByPSI3LjYiLz4KICA8L2c+Cjwvc3ZnPgo=')`;
			}
			if (props.icon === 'brain') {
				return `url('data:image/svg+xml;base64,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')`;
			}
			return 'none';
		}};
		background-position: center;
		border-radius: 50%;
		background-size: 28px;
		color: ${(props) => (props.icon ? 'transparent' : 'var(--c-white)')};
		content: counter(outcome-counter);
		display: flex;
		font-family: var(--font-semibold);
		font-size: 1.6rem;
		height: 28px;
		justify-content: center;
		left: -40px;
		position: absolute;
		width: 28px;
	}

	.sub-list p {
		margin-left: var(--spacing-4);
		position: relative;
	}

	.sub-list p::before {
		background-color: #f7be56;
		border-radius: 50%;
		content: '';
		height: 8px;
		left: -16px;
		position: absolute;
		top: 8px;
		width: 8px;
	}
`;

export const GlobalBodyStyle = createGlobalStyle`
	body {
		overflow: hidden;
	}
`;

export const GlobalAlignmentStyle = createGlobalStyle`
	#root {
		display: flex;
   	flex-flow: column;
		height: 100%;

		${media.smallScreen} {
			height: 100vh;
		}
	}
`;

export const GlobalAdminStyle = createGlobalStyle`
	#root {
		display: grid;
		flex-direction: column;
		grid-template-rows: 100px auto;
	}
`;

export const ParentAlignmentStyle = createGlobalStyle`
	body {
		background-color: var(--neutral-50);
	}
`;

export const GlobalModalStyle = createGlobalStyle`
	.ReactModal__Overlay {
		opacity: 0;
		transition: opacity 300ms ease-in-out;
	}

	.ReactModal__Overlay--after-open {
		opacity: 1;
	}

	.ReactModal__Overlay--before-close {
		opacity: 0;
	}

	/* .quill {
		background-color: var(--neutral-50);
		width: 100%; 
	}

	.quill.read-only-editor {
	.ql-picker-label,
		button {
			cursor: default;
			pointer-events: none;
		}

		.ql-formats {
			display: none;
		}

		.ql-toolbar  {
			padding: 8px 16px;

			&:after {
				content: 'Read Only';
				font-style: italic;
			}
		}
	}

	.ql-toolbar {
		background-color: var(--c-white);
		border-radius: 4px 4px 0 0;
	}

	.ql-container {
		border-radius: 0 0 4px 4px;
	}

	.ql-picker-label {
		outline-color: var(--wine-btn);
	}

	.ql-editor{
		font-size: 1.6rem;
    	min-height: 150px;
		font-family: var(--font-regular);
	}

	.ql-editor p:only-child {

		.new-line-indicator {
			content: none;

			&:before {
				background: transparent;
			}
		}
	}

	.ql-editor .new-line-indicator {
		content: '';
		margin-bottom: 6px;
		position: relative;

		&:before {
			background-color: hsl(7, 97%, 64%);
			background: linear-gradient(90deg, hsl(7, 97%, 64%), 50%, transparent 0);
			content: ' ';
			left: -10px;
			position: relative;
		}
	}

	.ql-editor p {
		position: relative;
		margin-bottom: 2px;
	}

	.ql-omega {
		margin-right: 5px;
	}

	.ql-picker.ql-omega .ql-picker-label:before {
    	content: "Select Tag";
	}

	.ql-picker.ql-omega .ql-picker-label {
    	padding-right: 16px;
	}

	.ql-omega .ql-picker-item:before {
		content: attr(data-label);
	}

	.ql-snow .ql-picker-options .ql-picker-item {
		padding: var(--spacing-2) var(--spacing-4) var(--spacing-2) var(--spacing-2);
		position: relative;

		&:hover {
			background-color: var(--grey-focus-bg);

			&:before {
				color: #444;
			}
		}
	}

	.ql-omega .ql-picker-options {
		max-height: 300px;
		padding: var(--spacing-2);
   		overflow: auto;
	}

	.ql-omega .ql-picker-item .dot {
		border-radius: 50%;
		height: 10px;
		position: absolute;
		top: 50%;
		transform: translate(5px, -50%);
		width: 10px;
	}

	.ql-omega.ql-expanded .ql-picker-label {
		border: none !important;
	} */

	.tagged-word {
		cursor: auto;
	}
`;

export const StyledSearch = styled.div`
	margin: 0 var(--spacing-8) var(--spacing-4);
	position: relative;
	align-self: stretch;

	.search-icon {
		position: absolute;
		left: 12px;
		top: 50%;
		transform: translateY(-50%);
	}

	input {
		border-radius: 6px;
		border: 1px solid var(--input-border);
		width: 100%;
		padding: var(--spacing-2) var(--spacing-4) var(--spacing-2) var(--spacing-10);

		&:focus {
			outline: none;
			border-color: var(--input-focus);
		}
	}
`;

export const StyledTextArea = styled(TextareaAutosize)`
	border: 1px solid var(--input-border);
	border-radius: 6px;
	padding: var(--spacing-2) var(--spacing-4);
	width: 100%;

	&:focus {
		outline: none;
		border-color: var(--input-focus);
	}
`;

export const StyledHR = styled.hr`
	border: none;
	box-shadow: 0px 2px 0px -1px rgb(50 50 50 / 10%);
	margin-bottom: var(--spacing-6);
	padding-bottom: var(--spacing-4);
	width: 100%;
`;

interface StyledCheckboxProps {
	isOrg?: boolean;
}

export const StyledCheckbox = styled.input<StyledCheckboxProps>`
	appearance: none;
	background-color: rgba(255, 255, 255, 0.01);
	border-radius: 3px;
	border: 2px solid;
	border-color: ${(props) => (props.isOrg ? ' var(--org-color)' : ' var(--elevate-primary)')};
	color: currentColor;
	cursor: pointer;
	display: grid;
	font: inherit;
	height: 20px;
	margin: 0;
	place-content: center;
	transform: translateY(-0.075em);
	width: 20px;

	&:before {
		/* Windows High Contrast Mode */
		background-color: CanvasText;
		box-shadow: inset 1em 1em var(--c-white);
		clip-path: polygon(1% 61%, 14% 48%, 33% 68%, 87% 14%, 100% 24%, 33% 91%);
		content: '';
		height: 8px;
		transform-origin: center;
		transform: scale(0);
		transition: 120ms transform ease-in-out;
		width: 8px;
	}

	&:checked::before {
		transform: scale(1.4);
	}

	&:checked {
		background-color: ${(props) => (props.isOrg ? ' var(--org-color)' : ' var(--elevate-primary)')};
	}

	&:focus-visible {
		outline: max(2px, 0.15em) solid;
		outline-color: ${(props) => (props.isOrg ? ' var(--org-color)' : ' var(--elevate-primary)')};
		outline-offset: max(2px, 0.15em);
	}

	&:disabled {
		background-color: var(--btn-disabled);
		border-color: var(--btn-disabled);
		cursor: not-allowed;
	}
`;

export const StyledCheckboxLabel = styled.label`
	align-items: center;
	cursor: pointer;
	display: flex;

	input {
		margin-right: var(--spacing-2);
	}
`;
